/*
 * Scroll-linked entrance for the A+ panel render.
 *
 * Writes --aplus-slide (1 = off beyond the right edge, 0 = arrived) and --aplus-grow (0 = at the
 * arrival size, 1 = grown into place) from the element's position on
 * screen. Because it reads scroll position rather than firing once on an intersection, it runs
 * backwards when the reader scrolls up and holds at 0 once they scroll past — which an
 * IntersectionObserver reveal cannot do, since it unobserves as soon as it fires.
 *
 * Fails to NO MOTION, never to no content: the CSS resting state is --aplus-slide: 0, so if this
 * file never loads, or the element is never matched, the render sits exactly where it belongs.
 * The version this replaced hid the figure in CSS and depended on JS to reveal it, and one class
 * that never arrived left the render invisible.
 */
(function () {
  if (window.__aplusSlideInit) return;
  window.__aplusSlideInit = true;

  var els = [];
  var ticking = false;

  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

  /* Where in the viewport the entrance runs, as a fraction of viewport height measured from the
     top. It begins once the section's top has risen to START and finishes at END.

     These were 1.0 and 0.55 — the run began the instant the section's top touched the BOTTOM edge
     and was over by the time it reached the middle, so the render had finished arriving while the
     reader was still looking at the section above it. Now nothing moves until the section is a
     third of the way up the screen, and it settles as the section fills it. */
  var START = 0.65;
  var END = 0.1;

  /* The phone runs a different entrance, so it runs a different window.

     It began at 1.0 — the instant the section's top cleared the bottom edge — and finished by
     0.55, which packed the whole travel into 45% of a viewport while the section was barely on
     screen. That is what read as clunky: it was over before the section had settled, so the eye
     caught the end of it rather than the move. Now it waits until the section is properly coming
     up (0.85) and takes half a viewport to arrive, so the travel is both later and longer. */
  var MOBILE_START = 0.85;
  var MOBILE_END = 0.35;
  var desktop = window.matchMedia && matchMedia('(min-width: 750px)');

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)');

  function update() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (!vh) return;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var top = el.getBoundingClientRect().top;
      /* 0 while the element's top is still at the bottom of the screen, 1 once it has travelled
         45% of a viewport up from there. Clamped at both ends, so scrolling further leaves it
         settled rather than carrying on past its resting place. */
      var wide = !desktop || desktop.matches;
      var a = wide ? START : MOBILE_START;
      var b = wide ? END : MOBILE_END;
      var p = clamp01((a * vh - top) / ((a - b) * vh));

      var slide, grow;
      if (wide) {
        /* Two phases, in the order the frames set them out: the render travels in from beyond the
           right edge over the first half, and only once it is flush does it grow into place. One
           eased value doing both at once would pass through none of the three frames. */
        slide = clamp01(1 - p / 0.5);
        grow = clamp01((p - 0.5) / 0.5);
      } else {
        /* The phone gets the slide and nothing else — one phase, and grow pinned at 1 so the
           scale term in the CSS resolves to no scale at all rather than animating. */
        slide = 1 - p;
        grow = 1;
      }
      el.style.setProperty('--aplus-slide', slide.toFixed(4));
      el.style.setProperty('--aplus-grow', grow.toFixed(4));
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function collect() {
    els = Array.prototype.slice.call(document.querySelectorAll('[data-aplus-slide]'));
  }

  function clear() {
    for (var i = 0; i < els.length; i++) {
      els[i].style.removeProperty('--aplus-slide');
      els[i].style.removeProperty('--aplus-grow');
    }
  }

  function sync() {
    collect();
    if (!els.length) return;
    if (reduce && reduce.matches) { clear(); return; }
    update();
  }

  function init() {
    sync();
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    /* Honour a change of preference in the same session rather than only at load. */
    if (reduce && reduce.addEventListener) reduce.addEventListener('change', sync);
    /* Crossing the breakpoint swaps both the window and the number of phases, so it has to
       re-evaluate rather than hold whatever the other side last wrote. */
    if (desktop && desktop.addEventListener) desktop.addEventListener('change', sync);
    /* The theme editor re-renders sections in place; re-collect rather than hold stale nodes. */
    document.addEventListener('shopify:section:load', sync);
    document.addEventListener('shopify:section:unload', collect);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
